import {PageView} from "./PageView.js";
import {UserProfileLayout} from "../components/layout/UserProfileLayout.js";
import {InputValidator} from "../util/input-validate/inputValidation.js";
import {
	addCompanyName,
	addCompanySubDomain,
	addJobType,
	addPassword,
	addUserName, collectGtm, getEmail,
	getUser,
	getUserId, getUserName,
	isGuestUser,
	isSnsSignUp
} from "../store.js";
import {PasswordInput} from "../components/input/PasswordInput.js";
import {NameInput} from "../components/input/NameInput.js";
import {TermPopup} from "../components/popup/TermPopup.js";
import {LoadingPopup} from "../components/popup/LoadingPopup.js";
import {AppSumoLayout} from "../components/layout/AppSumoLayout.js";
import {CompanyNameInput} from "../components/input/CompanyNameInput.js";
import {SubDomainInput} from "../components/input/SubDomainInput.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";

export class MorningmateAppSumo extends PageView {

	renderLayout() {
		const {mainText = '', subText = '', token = ''} = this.$props;
		const userId = getUserId();
		this.$props.AppSumoLayout = new AppSumoLayout(this.$target, {
			isAppend: true,
			sectionId: this.getSectionId(),
			mainText,
			subText,
			userId,
			token,
			nextButton: {
				text: this.getNextButtonText(),
				nextPageFunc: this.nextPage.bind(this)
			}
		});
	}

	renderComponents() {
		if (!this.$props.AppSumoLayout) {
			return;
		}

		this.$props.CompanyNameInput = new CompanyNameInput(this.$props.AppSumoLayout.getCompanyNameLayer(), {
			isLast: Often.isGlobal(),
			addClassName: this.getCommonJoinInputClassName(),
			submit: this.nextPage.bind(this)
		});

		this.$props.NameInput = new NameInput(this.$props.AppSumoLayout.getUserNameLayer(), {
			isLast: Often.isGlobal(),
			addClassName: this.getCommonJoinInputClassName(),
			submit: this.nextPage.bind(this),
		});

		this.$props.PasswordInput = new PasswordInput(this.$props.AppSumoLayout.getPasswordLayer(), {
			allowBlank: false,
			addClassName: this.getCommonJoinInputClassName()
		});


	}

	getSectionId() {
		return `profileInputSection`;
	}

	getCommonJoinInputClassName() {
		return `js-join-input`
	}

	async nextPage() {
		const $profileInputSection = $(`#${this.getSectionId()}`);
		const $profileInputs = $profileInputSection.find(`.${this.getCommonJoinInputClassName()}`);
		if (!InputValidator.inputsValidate($profileInputs)) {
			return;
		}

		this.addUserInfo();
		const {PASS_JSON = {}} = await getUser().createNewCompany();
		new LoadingPopup(this.$props.AppSumoLayout.getMainArticle(), {
			isAppend: true,
			loadingText: i18next.t(common.wait)
		});
		const CommonLogin = Mutil.requireIIFE("CommonLogin");
		CommonLogin.goLogin({...PASS_JSON});
	}

	addUserInfo() {
		addCompanyName(this.$props.CompanyNameInput.getInputValue())
		addCompanySubDomain(this.$props.CompanyNameInput.getSubDomain())
		addUserName(this.$props.NameInput.getInputValue());

		if (this.$props?.PasswordInput !== null) {
			addPassword(this.$props.PasswordInput.getInputValue());
		}
	}

}

